module.exports = __webpack_public_path__ + "static/img/1.3be110f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/1.png
// module id = l1Yh
// module chunks = 0